import PopupComponent from "@/components/embed/components/popup.ce.vue";

import { defineCustomElement } from "vue";

const FormesterPopup = defineCustomElement(PopupComponent);

customElements.define("formester-popup", FormesterPopup);

window.Formester = window.Formester || {};

window.Formester.openPopup = function(id) {
  const el = document.getElementById(id);
  if (!el) {
    console.warn(`Formester.openPopup: failed as element with id "${id}" not found`);
    return;
  }

  el._instance.exposed.handlePopupOpen();
}

window.Formester.closePopup = function(id) {
  const el = document.getElementById(id);
  if (!el) {
    console.warn(`Formester.closePopup: failed as element with id "${id}" not found`);
    return;
  }

  el._instance.exposed.handlePopupClose();
}
